const MagicWandIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      id="Wand--Streamline-Tabler"
      height="18"
      width="18"
      className="stroke-(--white) group-active/gen-button:stroke-(--main-light-blue) duration-150"
    >
      <desc>Wand Streamline Icon: https://streamlinehq.com</desc>
      <path d="M6 21 21 6l-3 -3L3 18l3 3" strokeWidth="2"></path>
      <path d="m15 6 3 3" strokeWidth="2"></path>
      <path
        d="M9 3a2 2 0 0 0 2 2 2 2 0 0 0 -2 2 2 2 0 0 0 -2 -2 2 2 0 0 0 2 -2"
        strokeWidth="2"
      ></path>
      <path
        d="M19 13a2 2 0 0 0 2 2 2 2 0 0 0 -2 2 2 2 0 0 0 -2 -2 2 2 0 0 0 2 -2"
        strokeWidth="2"
      ></path>
    </svg>
  );
};

export default MagicWandIcon;
